import { useContext } from "react"
import FormContext from "../FormContextMarsComplete"

const useGetFormContext = () => {
    return useContext(FormContext)
}

export default useGetFormContext